import ref from "services/firebaseRef.js";

export const USERREFERRAL_LOAD = "USERREFERRAL_LOAD";
export const USERREFERRAL_LOADED = "USERREFERRAL_LOADED";
export const USERREFERRAL_LOADERROR = "USERREFERRAL_LOADERROR";
export const USERREFERRAL_GENERATE = "USERREFERRAL_GENERATE";
export const USERREFERRAL_GENERATED = "USERREFERRAL_GENERATED";
export const USERREFERRAL_GENERATEERROR = "USERREFERRAL_GENERATEERROR";

function userRefferalLoad(userId) {
  return {
    type: USERREFERRAL_LOAD,
    userId
  }
}

function userReferralLoaded(userId, referralData) {
  return {
    type: USERREFERRAL_LOADED,
    userId,
    ...referralData
  }
}

function userRefferalLoadError(userId, err) {
  return {
    type: USERREFERRAL_LOADERROR,
    userId,
    message: err.message,
    stack: err.stack
  }
}

export function loadUserReferral(userId) {
  return dispatch => {
    dispatch(userRefferalLoad(userId));
    ref.child('users').child(userId).child('referral')
      .once('value', snapshot => {
        dispatch(userReferralLoaded(userId, snapshot.val()));
      }, err => {
        dispatch(userRefferalLoadError(userId, err))
      });
  };
}

function userReferralGenerate(userId) {
  return {
    type: USERREFERRAL_GENERATE,
    userId
  }
}

function userReferralGenerated(userId, referralData) {
  return {
    type: USERREFERRAL_GENERATED,
    userId,
    ...referralData
  }
}

function userReferralGenerateError(userId, error) {
  return {
    type: USERREFERRAL_GENERATEERROR,
    userId,
    message: error.message,
    stack: error.stack
  }
}

function normalizeName(name) {
  return name.trim().toLowerCase().replace(/[^a-z]/ig,"");
}

function findReferrerId(userId, firstName, lastName, index = 0) {
  return new Promise((resolve, reject) => {
    const referrerId = `${normalizeName(firstName)}${normalizeName(lastName)[0]}${index > 0 ? index + 1 : ''}`;
    ref.child('referrers').child(referrerId)
      .once('value', snapshot => {
        const value = snapshot.val();
        if (!value) {
          snapshot.ref.set({userId}, err => {
            if (err) return reject(err);
            resolve(referrerId);
          });
        } else {
          resolve();
        }
      }, reject);
  }).then(referrerId => {
    if (referrerId) return referrerId;
    return findReferrerId(userId, firstName, lastName, index + 1);
  });
}

export function generateUserReferral(userId, firstName, lastName) {
  return dispatch => {
    dispatch(userReferralGenerate(userId));
    findReferrerId(userId, firstName, lastName)
      .then(referrerId => {
        return ref.child('users').child(userId).child('referral')
          .set({referrerId})
          .then(() => dispatch(userReferralGenerated(userId, {referrerId})));
      })
      .catch(err => dispatch(userReferralGenerateError(userId, err)));
  }
}


// WEBPACK FOOTER //
// ./src/actions/referralActions.js